/* istanbul ignore file */
import { AuthProviderProps } from 'react-oidc-context';

const oidcConfig = {
    client_id: process.env.REACT_APP_AUTH_CLIENT_ID,
    authority: process.env.REACT_APP_AUTH_AUTHORITY,
    redirect_uri: process.env.REACT_APP_AUTH_REDIRECT_URI,
    post_logout_redirect_uri: process.env.REACT_APP_AUTH_POST_LOGOUT_URL,
    includeIdTokenInSilentSignout: true,
    includeIdTokenInSilentRenew: true,
    response_type: 'code',
    scope: `${process.env.REACT_APP_AUTH_CLIENT_ID}/.default openid profile email`,
    onSigninCallback: () => {
        window.history.replaceState(
            {},
            document.title,
            window.location.pathname
        );
    },
} as AuthProviderProps;

export default oidcConfig;
